import $http from 'utils/fetch'

export const getNewsList = query =>
  $http.get('/article/list', { params: query })

export const getNewsDetail = query =>
  $http.get('/article/detail', { params: query })



// WEBPACK FOOTER //
// ./src/api/news.js